module.exports = __webpack_public_path__ + "img/sector.16d6b9e7.svg";